export class Therapeutic {
  code_class_1: string;
  code_class_2: string;
  code_class_3: string;
  code: string;
  description: string;
}

export enum TherapeuticType {
  CLASS1, CLASS2, CLASS3, CLASS4
}

